"use client";

import type { FC, ReactNode } from "react";
import { useState } from "react";
import { cn } from "../../utils";
import computeVariantCopy from "./computeVariantCopy";
import computeVariantStyle, {
  type GameRtpListVariant,
} from "./computeVariantStyle";
import GameRtpListBody from "./GameRtpListBody";
import GameRtpListHeader from "./GameRtpListHeader";
import type { GameRtpListItem } from "./GameRtpListRow";

type Props = {
  title?: string;
  variant: GameRtpListVariant;
  items: GameRtpListItem[];
  infoContent?: ReactNode;
  translations?: Record<string, string>;
  onInfoClick?: () => void;
};

const GameRtpList: FC<Props> = ({
  title,
  variant,
  items,
  infoContent,
  translations,
  onInfoClick,
}) => {
  const { bg } = computeVariantStyle(variant);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const handleInfoClick = () => {
    setIsInfoOpen((open) => !open);
    onInfoClick?.();
  };

  return (
    <div
      data-slot="game-rtp-list"
      className={cn("overflow-hidden rounded-[20px] bg-card", bg)}
    >
      <GameRtpListHeader
        title={title ?? computeVariantCopy(variant, translations).title}
        variant={variant}
        hasInfo={infoContent != null}
        isInfoOpen={isInfoOpen}
        translations={translations}
        onInfoClick={handleInfoClick}
      />
      <GameRtpListBody
        isInfoOpen={isInfoOpen}
        infoContent={infoContent}
        items={items}
        variant={variant}
      />
    </div>
  );
};

export default GameRtpList;
export type { GameRtpTrend } from "./computeRtpTrend";
export { default as computeVariantCopy } from "./computeVariantCopy";
export type { GameRtpListVariant } from "./computeVariantStyle";
export { default as GameRtpListHeader } from "./GameRtpListHeader";
export { default as GameRtpListInfo } from "./GameRtpListInfo";
export type { GameRtpListItem } from "./GameRtpListRow";
export { default as GameRtpListRow } from "./GameRtpListRow";
export { GAME_RTP_LIST_TRANSLATION_KEYS } from "./translationKeys";
export { computeVariantStyle };
